// updated code
import { useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router";
import Header from "../core/common/header";
import Sidebar from "../core/common/sidebar";
import ThemeSettings from "../core/common/theme-settings";
import { useEffect, useState } from "react";
import HorizontalSidebar from "../core/common/horizontal-sidebar";
import TwoColumnSidebar from "../core/common/two-column";
import StackedSidebar from "../core/common/stacked-sidebar";
import DeleteModal from "../core/modals/deleteModal";
import Footer from "../core/common/footer";

const Feature = () => {
  const [showLoader, setShowLoader] = useState(true);

  // Local dummy states (instead of redux)
  // const [headerCollapse] = useState(false);
  const headerCollapse = useSelector(
    (state: any) => state.themeSetting.headerCollapse
  );
  // const [mobileSidebar] = useState(false);
  const mobileSidebar = useSelector(
    (state: any) => state.sidebarSlice.mobileSidebar
  );
  // const [miniSidebar] = useState(false);
  const miniSidebar = useSelector(
    (state: any) => state.sidebarSlice.miniSidebar
  );
  // const [expandMenu] = useState(false);
  const expandMenu = useSelector((state: any) => state.sidebarSlice.expandMenu);

  // const [dataWidth] = useState("full"); // box / full
  const dataWidth = useSelector((state: any) => state.themeSetting.dataWidth);

  // const [dataLayout] = useState("vertical"); // mini / horizontal
  const dataLayout = useSelector((state: any) => state.themeSetting.dataLayout);



  // const [dataLoader] = useState("disable"); // disable / enable
  const dataLoader = useSelector((state: any) => state.themeSetting.dataLoader);


  // const [dataTheme] = useState("light_data_theme");
  const dataTheme = useSelector((state: any) => state.themeSetting.dataTheme);

  // const [dataSidebarAll] = useState("#2e3b4e");
  const dataSidebarAll = useSelector(
    (state: any) => state.themeSetting.dataSidebarAll
  );
  // const [dataColorAll] = useState("#0d6efd");
  const dataColorAll = useSelector(
    (state: any) => state.themeSetting.dataColorAll
  );


  // const [dataTopBarColorAll] = useState("#ffffff");
  const dataTopBarColorAll = useSelector(
    (state: any) => state.themeSetting.dataTopBarColorAll
  );

  // const [dataTopbarAll] = useState("#f8f9fa");
  const dataTopbarAll = useSelector(
    (state: any) => state.themeSetting.dataTopbarAll
  );


  const location = useLocation();

  // Theme handling
  useEffect(() => {
    if (dataTheme === "dark_data_theme") {
      document.documentElement.setAttribute("data-theme", "darks");
    } else {
      document.documentElement.setAttribute("data-theme", "");
    }
  }, [dataTheme]);

  // Loader handling
  useEffect(() => {
    if (dataLoader === "disable") {
      setShowLoader(true);

      const timeoutId = setTimeout(() => {
        setShowLoader(false);
      }, 500);
      return () => clearTimeout(timeoutId);
    } else {
      setShowLoader(false);
    }
    window.scrollTo(0, 0);
  }, [location.pathname, dataLoader]);

  const Preloader = () => (
    <div id="global-loader" style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      height: "100vh"
    }}>
      <div className="page-loader"></div>
      <p style={{ marginTop: "15px", fontSize: "18px", fontWeight: "bold" }}>
        Loading...
      </p>
    </div>
  );


  return (
    <>
      <style>
        {`
          :root {
            --sidebar--rgb-picr: ${dataSidebarAll};
            --topbar--rgb-picr:${dataTopbarAll};
            --topbarcolor--rgb-picr:${dataTopBarColorAll};
            --primary-rgb-picr:${dataColorAll};
          }
        `}
      </style>

      <div
        className={`
          ${dataLayout === "mini" || dataWidth === "box" ? "mini-sidebar" : ""}
          ${["horizontal", "horizontal-single", "horizontal-overlay", "horizontal-box"].includes(dataLayout) ? "menu-horizontal" : ""}
          ${miniSidebar && dataLayout !== "mini" ? "mini-sidebar" : ""}
          ${dataWidth === "box" ? "layout-box-mode" : ""}
          ${headerCollapse ? "header-collapse" : ""}
          ${((expandMenu && miniSidebar) || (expandMenu && dataLayout === "mini")) ? "expand-menu" : ""}
        `}
      >
        <>
          {showLoader && <Preloader />}
          <div className={`main-wrapper ${mobileSidebar ? "slide-nav" : ""}`}>
            <Header />
            <Sidebar />
            <HorizontalSidebar />
            <TwoColumnSidebar />
            <StackedSidebar />
            <Outlet />
            <Footer />
            <DeleteModal />
            {!location.pathname.includes("layout") && <ThemeSettings />}
          </div>
        </>
        <div className="sidebar-overlay"></div>
      </div>
    </>
  );
};

export default Feature;





// // working Vk

// // import { useSelector } from "react-redux";
// import { Outlet, useLocation } from "react-router";
// import Header from "../core/common/header";
// import Sidebar from "../core/common/sidebar";
// import ThemeSettings from "../core/common/theme-settings";
// import { useEffect, useState } from "react";
// import HorizontalSidebar from "../core/common/horizontal-sidebar";
// import TwoColumnSidebar from "../core/common/two-column";
// import StackedSidebar from "../core/common/stacked-sidebar";
// import DeleteModal from "../core/modals/deleteModal";

// const Feature = () => {
//   const [showLoader, setShowLoader] = useState(true);


//   // Redux Selectors
//   const headerCollapse = useSelector(
//     (state: any) => state.themeSetting.headerCollapse
//   );

//   const mobileSidebar = useSelector(
//     (state: any) => state.sidebarSlice.mobileSidebar
//   );
//   const miniSidebar = useSelector(
//     (state: any) => state.sidebarSlice.miniSidebar
//   );
//   const expandMenu = useSelector((state: any) => state.sidebarSlice.expandMenu);
//   const dataWidth = useSelector((state: any) => state.themeSetting.dataWidth);
//   const dataLayout = useSelector((state: any) => state.themeSetting.dataLayout);
//   const dataLoader = useSelector((state: any) => state.themeSetting.dataLoader);
//   const dataTheme = useSelector((state: any) => state.themeSetting.dataTheme);
//   const dataSidebarAll = useSelector(
//     (state: any) => state.themeSetting.dataSidebarAll
//   );
//   const dataColorAll = useSelector(
//     (state: any) => state.themeSetting.dataColorAll
//   );
//   const dataTopBarColorAll = useSelector(
//     (state: any) => state.themeSetting.dataTopBarColorAll
//   );
//   const dataTopbarAll = useSelector(
//     (state: any) => state.themeSetting.dataTopbarAll
//   );
//   const location = useLocation();
//   useEffect(() => {
//     if (dataTheme === "dark_data_theme") {
//       document.documentElement.setAttribute("data-theme", "darks");
//     } else {
//       document.documentElement.setAttribute("data-theme", "");
//     }
//   }, [dataTheme]);

//   useEffect(() => {
//     if (dataLoader === "disable") {
//       // Show the loader when navigating to a new route
//       setShowLoader(true);

//       // Hide the loader after 2 seconds
//       const timeoutId = setTimeout(() => {
//         setShowLoader(false);
//       }, 2000);

//       return () => {
//         clearTimeout(timeoutId); // Clear the timeout when component unmounts
//       };
//     } else {
//       setShowLoader(false);
//     }
//     window.scrollTo(0, 0);
//   }, [location.pathname, dataLoader]);
//   const Preloader = () => {
//     return (
//       <div id="global-loader">
//         <div className="page-loader"></div>
//       </div>
//     );
//   };
//   return (
//     <>
//       <style>
//         {`
//       :root {
//         --sidebar--rgb-picr: ${dataSidebarAll};
//         --topbar--rgb-picr:${dataTopbarAll};
//         --topbarcolor--rgb-picr:${dataTopBarColorAll};
//         --primary-rgb-picr:${dataColorAll};
//       }
//     `}
//       </style>
//       <div
//         className={`
//        ${dataLayout === "mini" || dataWidth === "box" ? "mini-sidebar" : ""}
//        ${dataLayout === "horizontal" ||
//             dataLayout === "horizontal-single" ||
//             dataLayout === "horizontal-overlay" ||
//             dataLayout === "horizontal-box"
//             ? "menu-horizontal"
//             : ""
//           }
//       ${miniSidebar && dataLayout !== "mini" ? "mini-sidebar" : ""}
//       ${dataWidth === "box" ? "layout-box-mode" : ""} ${headerCollapse ? "header-collapse" : ""
//           }
//      ${(expandMenu && miniSidebar) || (expandMenu && dataLayout === "mini")
//             ? "expand-menu"
//             : ""
//           }

//       `}
//       >
//         <>
//           {showLoader ? (
//             <>
//               <Preloader />
//               <div
//                 className={`main-wrapper
//                   ${mobileSidebar ? "slide-nav" : ""}`}
//               >
//                 <Header />
//                 <Sidebar />
//                 <HorizontalSidebar />
//                 <TwoColumnSidebar />
//                 <StackedSidebar />
//                 <Outlet />
//                 <DeleteModal />
//                 {!location.pathname.includes("layout") && <ThemeSettings />}
//               </div>
//             </>
//           ) : (
//             <>
//               <div
//                 className={`main-wrapper
//                                ${mobileSidebar ? "slide-nav" : ""}`}
//               >
//                 <Header />
//                 <Sidebar />
//                 <HorizontalSidebar />
//                 <TwoColumnSidebar />
//                 <StackedSidebar />
//                 <Outlet />
//                 <DeleteModal />
//                 {!location.pathname.includes("layout") && <ThemeSettings />}
//               </div>
//             </>
//           )}
//         </>
//         {/* <Loader/> */}

//         <div className="sidebar-overlay"></div>
//       </div>
//     </>
//   );
// };

// export default Feature;


// old original code
// import { useSelector } from "react-redux";
// import { Outlet, useLocation } from "react-router";
// import Header from "../core/common/header";
// import Sidebar from "../core/common/sidebar";
// import ThemeSettings from "../core/common/theme-settings";
// import { useEffect, useState } from "react";
// import HorizontalSidebar from "../core/common/horizontal-sidebar";
// import TwoColumnSidebar from "../core/common/two-column";
// import StackedSidebar from "../core/common/stacked-sidebar";
// import DeleteModal from "../core/modals/deleteModal";

// const Feature = () => {
//   const [showLoader, setShowLoader] = useState(true);
//   const headerCollapse = useSelector(
//     (state: any) => state.themeSetting.headerCollapse
//   );
//   const mobileSidebar = useSelector(
//     (state: any) => state.sidebarSlice.mobileSidebar
//   );
//   const miniSidebar = useSelector(
//     (state: any) => state.sidebarSlice.miniSidebar
//   );
//   const expandMenu = useSelector((state: any) => state.sidebarSlice.expandMenu);
//   const dataWidth = useSelector((state: any) => state.themeSetting.dataWidth);
//   const dataLayout = useSelector((state: any) => state.themeSetting.dataLayout);
//   const dataLoader = useSelector((state: any) => state.themeSetting.dataLoader);
//   const dataTheme = useSelector((state: any) => state.themeSetting.dataTheme);
//   const dataSidebarAll = useSelector(
//     (state: any) => state.themeSetting.dataSidebarAll
//   );
//   const dataColorAll = useSelector(
//     (state: any) => state.themeSetting.dataColorAll
//   );
//   const dataTopBarColorAll = useSelector(
//     (state: any) => state.themeSetting.dataTopBarColorAll
//   );
//   const dataTopbarAll = useSelector(
//     (state: any) => state.themeSetting.dataTopbarAll
//   );
//   const location = useLocation();


//   useEffect(() => {
//     if (dataTheme === "dark_data_theme") {
//       document.documentElement.setAttribute("data-theme", "darks");
//     } else {
//       document.documentElement.setAttribute("data-theme", "");
//     }
//   }, [dataTheme]);



//   useEffect(() => {
//     if (dataLoader === "disable") {
//       // Show the loader when navigating to a new route
//       setShowLoader(true);

//       // Hide the loader after 2 seconds
//       const timeoutId = setTimeout(() => {
//         setShowLoader(false);
//       }, 2000);

//       return () => {
//         clearTimeout(timeoutId); // Clear the timeout when component unmounts
//       };
//     } else {
//       setShowLoader(false);
//     }
//     window.scrollTo(0, 0);
//   }, [location.pathname, dataLoader]);


//   const Preloader = () => {
//     return (
//       <div id="global-loader">
//         <div className="page-loader"></div>
//       </div>
//     );
//   };


//   return (
//     <>
//       <style>
//         {`
//       :root {
//         --sidebar--rgb-picr: ${dataSidebarAll};
//         --topbar--rgb-picr:${dataTopbarAll};
//         --topbarcolor--rgb-picr:${dataTopBarColorAll};
//         --primary-rgb-picr:${dataColorAll};
//       }
//     `}
//       </style>
//       <div
//         className={`
//        ${dataLayout === "mini" || dataWidth === "box" ? "mini-sidebar" : ""}
//        ${dataLayout === "horizontal" ||
//             dataLayout === "horizontal-single" ||
//             dataLayout === "horizontal-overlay" ||
//             dataLayout === "horizontal-box"
//             ? "menu-horizontal"
//             : ""
//           }
//       ${miniSidebar && dataLayout !== "mini" ? "mini-sidebar" : ""}
//       ${dataWidth === "box" ? "layout-box-mode" : ""} ${headerCollapse ? "header-collapse" : ""
//           }
//      ${(expandMenu && miniSidebar) || (expandMenu && dataLayout === "mini")
//             ? "expand-menu"
//             : ""
//           }

//       `}
//       >
//         <>
//           {showLoader ? (
//             <>
//               <Preloader />
//               <div
//                 className={`main-wrapper
//                   ${mobileSidebar ? "slide-nav" : ""}`}
//               >
//                 <Header />
//                 <Sidebar />
//                 <HorizontalSidebar />
//                 <TwoColumnSidebar />
//                 <StackedSidebar />
//                 <Outlet />
//                 <DeleteModal />
//                 {!location.pathname.includes("layout") && <ThemeSettings />}
//               </div>
//             </>
//           ) : (
//             <>
//               <div
//                 className={`main-wrapper
//                                ${mobileSidebar ? "slide-nav" : ""}`}
//               >
//                 <Header />
//                 <Sidebar />
//                 <HorizontalSidebar />
//                 <TwoColumnSidebar />
//                 <StackedSidebar />
//                 <Outlet />
//                 <DeleteModal />
//                 {!location.pathname.includes("layout") && <ThemeSettings />}
//               </div>
//             </>
//           )}
//         </>
//         {/* <Loader/> */}

//         <div className="sidebar-overlay"></div>
//       </div>
//     </>
//   );
// };

// export default Feature;



